export enum CustomLogger {
    // Fontos, hogy itt a sorrend megegyezzen a backend oldali CustomLogger enummal.

    None = 0,
    Invoicing,
    StockCorrection,
    AutoTaskFinder,
}
